import supportModule from '../../support.module';
import angular from 'angular';

export default supportModule.component('supportViewCaseDynamic', {
    template: require('./supportViewCaseDynamic.component.html'),
    styleUrls: require('./supportViewCaseDynamic.component.css'),
    controller: [supportViewCaseDynamicComponent],
    bindToController: true,
    bindings: {
        items: '<'
    }
});

function supportViewCaseDynamicComponent() {
    var vm = this;
    vm.$onInit = init;
    vm.isString = angular.isString;
    function init() {}
}



// WEBPACK FOOTER //
// ./modules/support/components/support-view-case-dynamic/supportVIewCaseDynamic.component.js